// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TradeStatusEnum;
(function (TradeStatusEnum) {
    TradeStatusEnum[TradeStatusEnum["Increase"] = 0] = "Increase";
    TradeStatusEnum[TradeStatusEnum["Decrease"] = 1] = "Decrease";
    TradeStatusEnum[TradeStatusEnum["Open"] = 2] = "Open";
    TradeStatusEnum[TradeStatusEnum["Close"] = 3] = "Close";
    TradeStatusEnum[TradeStatusEnum["Reverce"] = 4] = "Reverce";
})(TradeStatusEnum || (TradeStatusEnum = {}));
export var TradeSideEnum;
(function (TradeSideEnum) {
    TradeSideEnum[TradeSideEnum["Long"] = 0] = "Long";
    TradeSideEnum[TradeSideEnum["Short"] = 1] = "Short";
    TradeSideEnum[TradeSideEnum["None"] = 255] = "None";
})(TradeSideEnum || (TradeSideEnum = {}));
